import { defineMessages } from 'react-intl';

export default defineMessages({
    AddressLabel: {
        id: 'common.directives.templates.ml-pup-add-location-dialog.Your Address',
        defaultMessage: 'Your Address'
    },
    LocationTypeLabel: {
        id: 'common.views.ml-pup-add-location.Location Type',
        defaultMessage: 'Location Type'
    },
    ResidenceTypeLabel: {
        id: 'common.views.ml-pup-add-location.Residence Type',
        defaultMessage: 'Residence Type'
    },
    requiredDwellingQuestions: {
        id: 'common.views.ml-pup-add-location.Dwelling Questions',
        defaultMessage: 'Please answer the dwelling questions.'
    },
    UnderlyingPolicyLabel: {
        id: 'common.views.ml-pup-add-location.My Policy Info',
        defaultMessage: 'My Policy Info'
    },
    DwellingUsageTooltipLabel: {
        id: 'common.directives.templates.ml-pup-add-location-dialog.What does this mean?',
        defaultMessage: 'What does this mean?'
    },
    DwellingUsageTooltipContent: {
        id: 'common.directives.templates.ml-pup-add-location-dialog.Usage Help message',
        defaultMessage: 'A seasonal home is used for only one or two seasons of the year.  A secondary home can be used year round but is used for less time than your primary home.'
    },
    LocationTypeTooltipLabel: {
        id: 'common.directives.templates.ml-pup-add-location-dialog.Type Help message title',
        defaultMessage: 'Which location type should I select?'
    },
    LocationTypeTooltipContent: {
        id: 'common.directives.templates.ml-pup-add-location-dialog.Type Help message',
        defaultMessage: 'Vacant land is land with no houses, offices or other permanent structures or land not being used at the present time but that may have utilities and infrastructure in place.'
    },
    LocationPopupTooltipLabel: {
        id: 'common.directives.templates.ml-pup-add-location-dialog.What does this mean?',
        defaultMessage: 'What does this mean?'
    },
    UnderlyingPolicyTooltipContent: {
        id: 'common.directives.templates.ml-pup-add-location-dialog.Underlying Policy Help message',
        defaultMessage: 'This is the insurance policy which provides coverage for this exposure.'
    },
    ExcludeLocationTooltipContent: {
        id: 'common.directive.templates.ml-pup-location-content.You have chosen to exclude this property from coverage under your Umbrella policy.',
        defaultMessage: 'You have chosen to exclude this property from coverage under your Umbrella policy.'
    },
    ExcludeLocationRadioTitle: {
        id: 'common.directives.templates.ml-pup-add-location-dialog.Would you like to exclude this property?',
        defaultMessage: 'Would you like to exclude this property?'
    },
    NameOfBusinessLabel: {
        id: 'common.views.ml-pup-add-location.Name of Business',
        defaultMessage: 'Name of Business'
    },
    residenceTypeRequiredErrorMessage: {
        id: 'common.views.ml-pup-add-location.Residence Type Required',
        defaultMessage: 'Residence Type is Required'
    },
    dwellingOccupancyRequiredErrorMessage: {
        id: 'common.views.ml-pup-add-location.Dwelling Occupancy Type Required',
        defaultMessage: 'Dwelling Occupancy is Required'
    },
    dwellingUsageRequiredErrorMessage: {
        id: 'common.views.ml-pup-add-location.Dwelling Usage Required',
        defaultMessage: 'Dwelling Usage is Required'
    }
});
